import { type FunctionComponent } from "react";

import Articles from "./articles.svg";
import DatePicker from "./date-picker.svg";
import KeyEvent from "./key-event.svg";
import { Filter, Left } from "./styles";
import Title from "./title.svg";

type Props = {
  className?: string;
};

export const PlusNewsAgendaLeftPlaceholder: FunctionComponent<Props> = () => (
  <Left>
    <Title />
    <Filter>
      <DatePicker />
      <KeyEvent />
    </Filter>
    <Articles />
  </Left>
);

PlusNewsAgendaLeftPlaceholder.displayName = "PlusNewsAgendaLeftPlaceholder";
